import styled from 'styled-components'

import { ContentPadded } from './ContentPadded'

export const ContentBottom = styled(ContentPadded)`
	/* margin-bottom: 16px; This is the correct default but has been changed to account for a bug for ABN in iOS (temporary) */
	margin-bottom: 48px;
`
